/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

if (typeof window.Theme == "undefined") {
  window.Theme = {};
  window.Theme.utils = {};
}

class BaseElement extends HTMLElement {
  constructor() {
    super();
    if (typeof this.onClick === "function") {
      this.addEventListener("click", this.onClick);
    }
    this.sectionId = this.getAttribute("section-id");
  }
  listenTo(event, fn, sameCtx = true) {
    window.addEventListener(event, (e) => {
      if ((e.detail.sectionId === this.sectionId && sameCtx) || !sameCtx) {
        fn.bind(this)(e, e.detail);
      }
    });
  }
  forwardEvent(eventName, data = {}) {
    let event = new CustomEvent(eventName, {
      bubbles: true,
      composed: true,
      detail: {
        sectionId: this.sectionId,
        ...data,
      },
    });
    this.dispatchEvent(event);
  }
  getSectionContainer() {
    if (!this.sectionId) return null;
    const sectionContainerId = `shopify-section-${this.sectionId}`;
    return document.getElementById(sectionContainerId);
  }
  connectedCallback() {
    if (this.elements) {
      for (const [key, value] of Object.entries(this.elements)) {
        this[`$${key}`] =
          value[0] === "*"
            ? Array.from(this.querySelectorAll(value.substring(1)))
            : this.querySelector(value);
      }
    }
    this.render();
  }
}

const moneyFormat = "${{amount}}";

function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;
  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}

window.Theme.utils.formatMoney = formatMoney;

window.Theme.BaseElement = BaseElement;

window.gm_authFailure = () => {
  document.querySelectorAll("google-map").forEach((map) => {
    if (map.onAuthError) map.onAuthError();
  });
};

document.addEventListener("DOMContentLoaded", function () {
  var header = document.querySelector("#MainHeader");
  var collectionSection = document.querySelector(".custom-collection-list");
  var headerInner = document.querySelector(".main-header-inner-container");
  var classToCheck = "@sticky"; // Change to "sticky" if you meant that

  if (!header || !collectionSection || !headerInner) {
    console.warn("Required elements not found.");
    return;
  }

  var headerHeight = header.offsetHeight;

  function checkScroll() {
    var scrollTop = window.scrollY;
    var headerHeightTop = headerHeight + 200;
    console.log("scroll:", scrollTop, "trigger:", headerHeightTop);

    if (header.classList.contains(classToCheck)) {
      var headerInnerHeight = headerInner.offsetHeight;
      collectionSection.style.top = headerInnerHeight + "px";
    } else {
      collectionSection.style.top = "0px";
      collectionSection.classList.remove("sticky_collection-list");
    }

    if (scrollTop >= headerHeightTop) {
      collectionSection.classList.add("sticky_collection-list");
    } else {
      // collectionSection.classList.remove("sticky_collection-list");
    }
  }

  // window.addEventListener("scroll", checkScroll);

  // Optional: run once on load
  // checkScroll();
});


document.addEventListener("DOMContentLoaded", function () {
  try {
    var inputSearch = document.querySelector(".input_search");
    var searchPopupInput = document.querySelector(".search-popup-input");

    if (inputSearch) {
      inputSearch.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          var searchText = inputSearch.value.trim().toLowerCase();

          // 1. Filter products
          var productItems = document.querySelectorAll(
            "#main-collection-product-grid .product-item"
          );
          var visibleCount = 0;
          productItems.forEach(function (item) {
            console.log(item, "itemitem>>>>");
            var productText = item.textContent.toLowerCase();
            if (productText.includes(searchText)) {
              item.style.display = "";
              visibleCount++;
            } else {
              item.style.display = "none";
            }
          });
          document.querySelector(
            "collection-grid-count"
          ).textContent = `${visibleCount} products`;

          // 2. Update URL (without reloading)
          var newUrl =
            window.location.pathname + "?q=" + encodeURIComponent(searchText);
          window.history.replaceState(null, "", newUrl);
          var inputSearchTitle = document.querySelector(".coll__title");
          // 3. Set the value in .search-popup-input
          if (searchPopupInput) {
            searchPopupInput.value = searchText;
            inputSearchTitle.textContent = searchText;
          }

          window.scrollTo(0, 0);
        }
      });
    }
  } catch (error) {
    console.error(error);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var searchInput = document.querySelector(".search-popup-input");

  if (searchInput) {
    searchInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        var inputSearch = this.value.trim();
        if (inputSearch !== "") {
          var encodedSearch = encodeURIComponent(inputSearch);
          window.location.href = "/collections/search?q=" + encodedSearch;
        }
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var urlParams = new URLSearchParams(window.location.search);
  var searchText = urlParams.get("q");

  if (searchText) {
    var searchInput = document.querySelector(".search-popup-input");
    var inputSearchTitle = document.querySelector(".coll__title");
    var inputSearch = document.querySelector(".input_search");

    // Set input values
    if (searchInput) searchInput.value = searchText;
    if (inputSearch) inputSearch.value = searchText;
    if (inputSearchTitle) inputSearchTitle.textContent = searchText;

    // Normalize search text
    searchText = searchText.toLowerCase();

    // Get all product items
    var productItems = document.querySelectorAll(
      "#main-collection-product-grid .product-item"
    );
    var visibleCount = 0;

    productItems.forEach(function (item) {
      var productText = item.textContent.toLowerCase();
      var tagText = item.getAttribute("data-tags") || "";
      var tagList = tagText.toLowerCase().split(",");

      var matchesTitle = productText.includes(searchText);
      var matchesTags = tagList.some((tag) => tag.includes(searchText));

      // Filter logic: check if item has show__product class + title/tags match
      if (matchesTitle || matchesTags) {
        item.style.display = "";
        visibleCount++;
      } else {
        item.style.display = "none";
      }
    });

    console.log("visibleCount>>>>>", visibleCount);

    // Fix: ID or class selector for collection-grid-count
    var countDisplay = document.querySelector("collection-grid-count"); // FIX: class selector
    if (countDisplay) {
      countDisplay.textContent = `${visibleCount} products`;
    }
  }
});

// document.querySelectorAll('.form-checkbox').forEach(function(checkbox) {
//   checkbox.addEventListener('change', function() {
//     console.log('Checkbox clicked:', checkbox);

//     const stickyParent = checkbox.closest('.sticky_wrap');
//     if (stickyParent) {
//       // Find an input inside stickyParent that you want to clear
//       const inputToClear = stickyParent.querySelector('input[type="text"], input:not([type="checkbox"])');
//       if (inputToClear) {
//         inputToClear.value = '';
//       }
//     }
//   });
// });

document.querySelectorAll(".mega__chevron-down").forEach((button) => {
  button.addEventListener("click", function (e) {
    e.preventDefault();

    const parentCol = this.closest(".main-nav-col");
    const menu = parentCol.querySelector(".main-nav-megamenu");

    // Close all other menus and remove active classes
    // document.querySelectorAll(".main-nav-megamenu").forEach((otherMenu) => {
    //   if (otherMenu !== menu) {
    //     otherMenu.style.display = "none";
    //     otherMenu.classList.remove("active");
    //   }
    // });

    document.querySelectorAll(".mega__chevron-down").forEach((otherBtn) => {
      if (otherBtn !== this) {
        otherBtn.classList.remove("active");
      }
    });

    // Toggle this menu
    if (menu.style.display === "block") {
      menu.style.display = "none";
      menu.classList.remove("active");
      this.classList.remove("active");
    } else {
      menu.style.display = "block";
      menu.classList.add("active");
      this.classList.add("active");
    }
  });
});
document.addEventListener("click", function (e) {
  const searchIcon = e.target.closest(".main_search-icon");
  if (searchIcon) {
    const wrapper = searchIcon.closest(".main-header-wrapper");
    if (wrapper) {
      const searchWrapper = wrapper.querySelector(".search__wrapper");
      if (searchWrapper) {
        searchWrapper.classList.remove("hide-mobile");
        document.body.classList.add("search_open");
      }
    }
  }
});

document.addEventListener("click", function (e) {
  const closeButton = e.target.closest(".icon_close");
  if (closeButton) {
    const wrapper = closeButton.closest(".main-header-wrapper");
    if (wrapper) {
      const searchWrapper = wrapper.querySelector(".search__wrapper");
      if (searchWrapper) {
        searchWrapper.classList.add("hide-mobile");
        document.body.classList.remove("search_open");
      }
    }
  }
});

